import { makeQueryStringFromObject } from '../apiHelper'
import apiClient from './apiClient'

export const AS_OBJECT = 'as-object'

export const getAllSections = parameters => apiClient.get(null, `public/sections${makeQueryStringFromObject(parameters)}`)